module.exports = require("rxjs/add/operator/map");